module.exports = __webpack_public_path__ + "img/florianopolis.1d9ff5a9.jpg";